(function ($) {
    const behavior = 'polyu_theme.views-5_kinds_of_basic_info_local_non_jupas_';
    Drupal.behaviors[behavior] = {
        attach: (context, settings) => {
            var count = 0;

            $(".basic-info-views-header-container").each(function () {
                count++;
                if ($('.container--view--5-kinds-of-basic-info-local-non-jupas---block-11').length){
                    return;
                }
                if (count > 1) {
                    $(this).remove();
                }
            });

            var count2 = 0;

            $(".underline-decor").each(function () {
                count2++;
                if ($('.container--view--5-kinds-of-basic-info-local-non-jupas---block-11').length){
                    return;
                }
                if (count2 > 1) {
                    $(this).remove();
                }
            })

            once(behavior, '.view-additional-documents .views-row', context).forEach(viewsField => {
                var selectorWord = ".views-field:nth-child(3) > .field-content > div.third-column-wrapper";
                $(selectorWord).addClass("show");
                $('.views-field:nth-child(3) > .field-content').each(function () {
                    var interviewArrangements = $(this).find('.interview-arrangement');
                    if (interviewArrangements.length > 1) {
                        interviewArrangements.not(":eq(0)").hide();
                    }
                });
                $(".views-field:nth-child(3)").css({'height': 'auto'});
            });

            once(behavior, '.view-interview-arrangement .views-row', context).forEach(viewsField => {
                var selectorWord = ".views-field:nth-child(3) > .field-content > div:first-child";
                $(selectorWord).addClass("show");
                if ($(window).width() < 767) {
                    $(".views-field-field-prog-interview-list").css({'height': 'auto', 'width': '805px'});
                    $(".views-field-field-prog-addt-doc-list").css({'height': '0', 'width': '0px', 'padding-top': '0'});
                } else {
                    $(".views-field-field-prog-interview-list").css({'height': 'auto', 'width': '805px'});
                    $(".views-field-field-prog-addt-doc-list").css({'height': '0', 'width': '0', 'margin': '0'});
                }
                $('.views-field:nth-child(3) > .field-content').each(function () {
                    var interviewArrangements = $(this).find('.interview-arrangement');
                    if (interviewArrangements.length > 1) {
                        interviewArrangements.not(":eq(0)").hide();
                    }
                });
                $(".views-field:nth-child(3)").css({'height': 'auto'});
            });
            once(behavior, '.additional-supporting-button', context).forEach(button => {
                $(button).on("click", function () {
                    if ($(window).width() < 767) {
                        $(".views-field-field-prog-interview-list").css({'height': '0', 'width': '0', 'margin': '0', 'padding-top': '0'});
                        $(".views-field-field-prog-addt-doc-list").css({'height': 'auto', 'width': '805px', 'padding-top': '36px'});
                    } else {
                        $(".views-field-field-prog-interview-list").css({'height': '0', 'width': '0', 'margin': '0'});
                        $(".views-field-field-prog-addt-doc-list").css({'height': 'auto', 'width': '805px'});
                    }

                    $(".views-field:nth-child(4) > .field-content > div:first-child").toggleClass('show');
                    $(".views-field:nth-child(3) > .field-content > div:first-child").toggleClass('show');

                });
            });
            once(behavior, '.interview-arrangement', context).forEach(button => {
                $(button).on("click", function () {
                    if ($(window).width() < 767) {
                        $(".views-field-field-prog-interview-list").css({'height': 'auto', 'width': '805px', 'padding-top': '36px'});
                        $(".views-field-field-prog-addt-doc-list").css({'height': '0', 'width': '0px', 'padding-top': '0'});
                    } else {
                        $(".views-field-field-prog-interview-list").css({'height': 'auto', 'width': '805px'});
                        $(".views-field-field-prog-addt-doc-list").css({'height': '0', 'width': '0', 'margin': '0'});
                    }

                    $(".views-field:nth-child(4) > .field-content > div:first-child").toggleClass('show');
                    $(".views-field:nth-child(3) > .field-content > div:first-child").toggleClass('show');


                });
            });
            // once(behavior, '.views-field-field-prog-addt-doc-list', context).forEach( div => {
            //    $(div).append("<div class=\"interview-arrangement\">Interview Arrangement</div>")
            // });

        }
    };
    $(function () {
        // Adds All faculties and schools into the filter bar, left hand side
        $("#select2-edit-field-prog-discipline-target-id-container").html("All Faculties and Schools");

        //JEE override
        $('.container--view--5-kinds-of-basic-info-local-non-jupas---block-9 #select2-edit-field-prog-discipline-target-id-container,.container--view--5-kinds-of-basic-info-local-non-jupas---block-10 #select2-edit-field-prog-discipline-target-id-container').html("所有专业");
    });

    //

})(jQuery);
